import React from 'react';
import { StarIcon, PlayIcon } from 'lucide-react';
import { salesPageData, Testimonial } from '../data/salesPageData';

/**
 * Sección de TESTIMONIOS.
 * Preparada para 4–6 testimonios reales (texto, captura de WhatsApp, foto, video,
 * nombre, ciudad y estrellas). No se publica mientras `testimonials` esté vacío:
 * no se muestran nombres, capturas ni valoraciones inventadas.
 * Para activarla, cargá los testimonios reales en `data/salesPageData.ts`.
 */
export function TestimonialsSection() {
  const testimonials = salesPageData.testimonials;
  if (testimonials.length === 0) return null;
  return <section className="border-t border-[#EFEDE8]/10 bg-[#111111]" aria-labelledby="testimonials-title" data-id="element-374" data-mp="141y5rz6k1p2m">
      <div className="mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-375" data-mp="183t54y4xdsdr">
        <h2 id="testimonials-title" className="reveal mx-auto max-w-3xl text-center font-display text-2xl font-black uppercase leading-[1.08] tracking-tight text-[#F8F3EA] sm:text-4xl" data-id="element-376" data-mp="2yfh0705agrjp">
          Lo que dicen quienes ya abrieron la Bóveda
        </h2>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-377" data-mp="2uzrj73d6vfl4">
          {testimonials.map((testimonial, i) => <TestimonialCard key={`${testimonial.name}-${i}`} testimonial={testimonial} data-id="element-378" data-mp="2q0eyao5voil6" data-mpi={i} />)}
        </ul>
      </div>
    </section>;
}
function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <li className="reveal flex flex-col overflow-hidden rounded-xl border border-[#EFEDE8]/10 bg-[#181512] p-6" data-id="element-379" data-mp="2zundyb9t8h1x">
      {testimonial.type === 'screenshot' && testimonial.media && <img src={testimonial.media} alt={`Captura del mensaje enviado por ${testimonial.name}`} className="mb-4 w-full rounded-lg border border-[#EFEDE8]/10" loading="lazy" data-id="element-380" data-mp="275ge98ymdlf3" />}

      {testimonial.type === 'video' && testimonial.media && <video src={testimonial.media} controls playsInline preload="none" poster={testimonial.photo || undefined} className="mb-4 w-full rounded-lg border border-[#EFEDE8]/10" aria-label={`Testimonio en video de ${testimonial.name}`} data-id="element-381" data-mp="1anftwfvptak">
          <PlayIcon className="h-5 w-5" aria-hidden="true" data-id="element-382" data-mp="3fk5sicp7n10" />
        </video>}

      {testimonial.stars > 0 && <div className="mb-3 flex gap-0.5" aria-label={`${testimonial.stars} de 5 estrellas`} data-id="element-383" data-mp="8cu1ugulewxt">
          {Array.from({
        length: testimonial.stars
      }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[#D89A3D] text-[#D89A3D]" aria-hidden="true" data-id="element-384" data-mp="ibrm37kzk4b0" data-mpi={i} />)}
        </div>}

      {testimonial.quote && <p className="text-[15px] leading-relaxed text-[#EFEDE8]/80" data-id="element-385" data-mp="3guq596us5lfd">
          “{testimonial.quote}”
        </p>}

      <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-386" data-mp="3lt9sdal4139b">
        {testimonial.photo && <img src={testimonial.photo} alt={`Foto de ${testimonial.name}`} className="h-10 w-10 rounded-full object-cover" loading="lazy" data-id="element-387" data-mp="3qqtgr3biuwez" />}
        <div data-id="element-388" data-mp="3vknzo4jaz7d0">
          <p className="font-display text-sm font-extrabold uppercase tracking-tight text-[#F8F3EA]" data-id="element-389" data-mp="2y374z7s54lh1">
            {testimonial.name}
          </p>
          {testimonial.city && <p className="text-xs text-[#EFEDE8]/55" data-id="element-390" data-mp="330fopcsxsxke">{testimonial.city}</p>}
        </div>
      </div>
    </li>;
}